module.exports = __webpack_public_path__ + "static/img/phone_2.006af0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone_2.png
// module id = QqBA
// module chunks = 0